export default {
  GET_CUSTOMER_INVESTOR_GOAL_BALANCE_QUERY: Symbol.for('GET_CUSTOMER_INVESTOR_GOAL_BALANCE_QUERY'),
  CUSTOMER_INVESTOR_GOAL_BALANCE_REPOSITORY: Symbol.for('CUSTOMER_INVESTOR_GOAL_BALANCE_REPOSITORY'),
  CUSTOMER_INVESTOR_GOAL_BALANCE_STATE_MANAGER: Symbol.for('CUSTOMER_INVESTOR_GOAL_BALANCE_STATE_MANAGER'),
};
